module.exports = __webpack_public_path__ + "static/media/404_man_robert.07e44393.png";